var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.4999 4C11.4999 3.72386 11.724 3.49826 11.9995 3.51666C13.1421 3.59294 14.2545 3.93009 15.25 4.50491C16.3902 5.16323 17.337 6.1101 17.9953 7.25034C18.6535 8.39058 19 9.684 18.9999 11.0006C18.9998 12.3172 18.6531 13.6105 17.9947 14.7507C17.3363 15.8908 16.3893 16.8375 15.249 17.4957C14.1087 18.1538 12.8153 18.5002 11.4987 18.5C10.1821 18.4998 8.88877 18.153 7.74869 17.4945C6.75323 16.9195 5.90524 16.1246 5.26806 15.1731C5.11442 14.9436 5.1978 14.6368 5.43697 14.4987L10.4995 11.5773C11.1185 11.2201 11.4999 10.5597 11.4999 9.84502V4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50481 13.75C3.02652 14.0261 2.4089 13.864 2.19081 13.3566C1.73647 12.2995 1.50006 11.1579 1.5 10.0004C1.49992 8.50853 1.89252 7.04288 2.63834 5.75077C3.38416 4.45865 4.45693 3.3856 5.74885 2.63945C6.75116 2.06056 7.85798 1.69425 9.00053 1.55896C9.54899 1.49402 9.99833 1.94772 9.99844 2.5L9.99988 9.42251C9.99995 9.77985 9.80935 10.1101 9.49988 10.2887L3.50481 13.75Z",
    fill: "currentColor",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsights);
export default __webpack_public_path__ + "static/media/icon-insights.fc306d4fbf5103be33484f91ac51cf54.svg";
export { ForwardRef as ReactComponent };